import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-already-earned-points',
  templateUrl: './already-earned-points.component.html',
  styleUrls: ['./already-earned-points.component.css']
})
export class AlreadyEarnedPointsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
